import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import type { VariantType as Variant } from 'motion-v'
import type { SocialIconName } from '~/lib/socialIcons'
import { m } from 'motion-v'
import { socialIconMap } from '~/lib/socialIcons'

type SocialVariant = 'white' | 'primary' | 'header' | 'footer'
type SocialSize = 'sm' | 'md' | 'lg'


export default /*@__PURE__*/_defineComponent({
  __name: 'MSocialLinks',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    sound: { type: Boolean, default: true }
  },
  setup(__props: any) {



const variantClass: Record<SocialVariant, string> = {
  white: 'text-white',
  primary: 'text-primary',
  header: 'text-monster-blue-900 dark:text-white',
  footer: 'text-brand-darker-red',
}

const sizeStyle: Record<SocialSize, { fontSize: string, width?: string }> = {
  sm: { fontSize: '1.5em' },
  md: { fontSize: '2em' },
  lg: { fontSize: '2em', width: '28px' },
}

const iconStyle = computed(() => sizeStyle[__props.size])
const colorClass = computed(() => variantClass[__props.variant])
const { play } = useSound()

const links: ReadonlyArray<{ name: string, href: string, icon: SocialIconName }> = [
  { name: 'YouTube', href: 'https://www.youtube.com/channel/UC-z28AAWkqUnGNo_TejEuPA', icon: 'square-youtube' },
  { name: 'X', href: 'https://twitter.com/MassiveMonster', icon: 'square-x-twitter' },
  { name: 'Bluesky', href: 'https://bsky.app/profile/cultofthelamb.bsky.social', icon: 'square-bluesky' },
  { name: 'Discord', href: 'https://discord.gg/MassiveMonster', icon: 'discord' },
] as const

const activeIndex = ref<number | null>(null)
const motionLink = m.a

function setActive(index: number) {
  activeIndex.value = index
  if (__props.sound)
    play('wobble', { throttle: 120, gain: 0.8, rateJitter: 0.05 })
}

function pressSound() {
  if (__props.sound)
    play('tick', { throttle: 80, rateJitter: 0.06 })
}

function linkMotion(index: number): Variant {
  if (activeIndex.value === null) {
    return {
      x: 0,
      y: 0,
      scale: 1,
      rotate: 0,
      transition: { type: 'spring', stiffness: 420, damping: 22, mass: 0.7 },
    }
  }

  const offset = activeIndex.value - index
  const distance = Math.abs(offset)
  const pull = Math.max(0, 3 - distance) / 3
  const direction = Math.sign(offset)

  return {
    x: direction * pull * 7,
    y: -12 * pull,
    scale: 1 + pull * 0.18,
    rotate: direction * pull * -7,
    transition: {
      type: 'spring',
      stiffness: 520 - distance * 70,
      damping: 14 + distance * 4,
      mass: 0.55 + distance * 0.14,
      delay: distance * 0.018,
    },
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "inline-flex items-center",
    onPointerleave: _cache[1] || (_cache[1] = ($event: any) => (activeIndex.value = null))
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link, index) => {
      return _createVNode(_resolveDynamicComponent(_unref(motionLink)), {
        key: link.name,
        class: _normalizeClass(["no-underline mx-2 inline-flex items-center justify-center origin-bottom", _unref(colorClass)]),
        href: link.href,
        "aria-label": link.name,
        title: link.name,
        target: "_blank",
        rel: "noopener noreferrer",
        animate: linkMotion(index),
        "while-press": { scale: 0.92, y: -2 },
        onPointerenter: ($event: any) => (setActive(index)),
        onFocus: ($event: any) => (setActive(index)),
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (activeIndex.value = null)),
        onClick: pressSound
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            name: _unref(socialIconMap)[link.icon],
            class: "text-inherit block",
            style: _normalizeStyle(_unref(iconStyle)),
            "aria-hidden": "true"
          }, null, 8, ["name", "style"])
        ]),
        _: 2
      }, 1064, ["class", "href", "aria-label", "title", "animate", "onPointerenter", "onFocus"])
    }), 64))
  ], 32))
}
}

})